import { isAttachmentStrategyUsingCheckoutButtons } from "@redotech/redo-model/team";
import { WidgetAutocheck } from "@redotech/redo-model/widget";
import { isDef } from "@redotech/util/checks";

export function isRIC(autocheck: WidgetAutocheck): boolean {
  const isCheckoutButtons =
    isDef(autocheck.widgetConfigs) &&
    autocheck.widgetConfigs.length > 0 &&
    isAttachmentStrategyUsingCheckoutButtons[autocheck.attachmentStrategy];

  return isCheckoutButtons;
}
